import script from "./DressingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DressingCard.vue?vue&type=script&setup=true&lang=js"

import "./DressingCard.vue?vue&type=style&index=0&id=0bd6f780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bd6f780"]])

export default __exports__